import React from 'react';
import { Newspaper, Award, Calendar } from 'lucide-react';

const News = () => {
  const newsItems = [
    {
      id: 1,
      title: "Chaturvedi Lab Receives NIH/NIGMS R35 MIRA Award",
      date: "2026",
      description: "We're excited to receive an NIH/NIGMS Maximizing Investigators' Research Award (R35 MIRA) to support our work on lineage-resolved transcriptional engineering and the principles that govern cellular decision-making across time.",
      icon: Award,
      highlight: true
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-amber-50 via-white to-indigo-50/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-indigo-100/30 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full glass-light border border-amber-200 mb-6 shadow-lg shadow-amber-100/50">
            <Newspaper className="h-5 w-5 text-amber-600" />
            <span className="text-sm font-bold text-amber-700 tracking-wide">LATEST NEWS</span>
          </div>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 leading-tight" 
            style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.02em' }}
          >
            Lab <span className="gradient-text">Updates</span>
          </h2>
          <div className="w-32 sm:w-40 h-2 bg-gradient-to-r from-amber-600 via-orange-500 to-amber-500 mx-auto rounded-full shadow-lg"></div>
        </div>

        {/* News Items */}
        <div className="grid gap-6 max-w-4xl mx-auto">
          {newsItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <div 
                key={item.id}
                className={`glass-light p-8 rounded-2xl border-2 transition-all duration-300 hover:shadow-2xl ${
                  item.highlight 
                    ? 'border-amber-300 hover:border-amber-400 bg-gradient-to-br from-amber-50/80 to-white' 
                    : 'border-indigo-100 hover:border-indigo-300'
                }`}
              >
                <div className="flex items-start gap-4">
                  {/* Icon */}
                  <div className="flex-shrink-0">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                      item.highlight 
                        ? 'bg-gradient-to-br from-amber-500 to-orange-500' 
                        : 'bg-gradient-to-br from-indigo-500 to-cyan-500'
                    } shadow-lg`}>
                      <IconComponent className="h-6 w-6 text-white" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <h3 
                        className="text-xl sm:text-2xl font-bold text-slate-900" 
                        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                      >
                        {item.title}
                      </h3>
                    </div>
                    
                    <div className="flex items-center gap-2 mb-3">
                      <Calendar className="h-4 w-4 text-slate-500" />
                      <span className="text-sm font-semibold text-slate-600">{item.date}</span>
                    </div>

                    <p className="text-base sm:text-lg text-slate-700 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default News;
